import React from 'react';
import { compose } from 'redux';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import SideBarContainer from 'containers/SideBarContainer';
import { Grid } from 'react-bootstrap';
import { ShutdownNoticeTile } from 'components/molecules/ErrorTile';

const ShutdownNoticePage = ({ children }) => (
    <DashboardTemplate
        header={<HeaderContainer hideLinks={true} />}
        sidebar={<SideBarContainer navItems={[]} />}
        title={<div style={{ height: '112px' }} />}>


        <Grid fluid={true}>
            <ShutdownNoticeTile>
                {children}
            </ShutdownNoticeTile>
        </Grid>
    </DashboardTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Shutdown Notice', showGGBranding: false }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': false } })
)(ShutdownNoticePage);



// WEBPACK FOOTER //
// ./src/components/pages/ShutdownNoticePage.js